/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// Import icons for editing and deleting actions
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";

// Functional component to represent a row in the table
export default function Tr({
  id, // Unique identifier for the row
  order, // Order number for display
  rank, // Rank value from the data
  color_hex_code, // Background color in hex format
  onEdit, // Function to handle the edit action
  onDelete, // Function to handle the delete action
  isAllowedToEditOrDelete, // Permission flag for edit/delete actions
}) {
  return (
    <>
      <tr>
        {/* Display the order number (1-based index) */}
        <td className="col-numeric-date">{order + 1}</td>
        {/* Display the rank */}
        <td className="col-numeric-date">{rank}</td>
        {/* Display the background color and its hex code */}
        <td className="col-numeric-date">
          <div className="color-box" style={{ backgroundColor: color_hex_code, margin: 'auto' }}></div>
        </td>
        <td className="col-options">
          {/* Edit button with conditional styling and click handler */}
          <a
            onClick={(e) => {
              isAllowedToEditOrDelete
                ? onEdit({ id, rank, color_hex_code }) // Call onEdit if editing is allowed
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permission
            }}
          >
            <img className="edit-delete-icons" src={edit_logo} alt="Edit" />
          </a>
          &nbsp;
          {/* Delete button with conditional styling and click handler */}
          <a
            onClick={(e) => {
              isAllowedToEditOrDelete
                ? onDelete({ id, rank, color_hex_code, delete: true }) // Call onDelete if deleting is allowed
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permission
            }}
          >
            <img className="edit-delete-icons ms-3" src={tash_logo} alt="Delete" />
          </a>
          &nbsp;
        </td>
      </tr>
    </>
  );
}
